import { TableCell, TableHeader } from '@tiptap/extension-table';
import Paragraph from '@tiptap/extension-paragraph';
import Heading from '@tiptap/extension-heading';

export const parseBorderDeclaration = (element: HTMLElement): string | null => {
    const borderDeclaration = element.getAttribute('style')?.match(/(?:^|;)\s*border\s*:\s*([^;]+)\s*(?:;|$)/i);

    return borderDeclaration?.[1].trim() ?? null;
};

export const parsePaddingDeclaration = (element: HTMLElement): string | null => {
    const paddingDeclaration = element.getAttribute('style')?.match(/(?:^|;)\s*padding\s*:\s*([^;]+)\s*(?:;|$)/i);

    return paddingDeclaration?.[1].trim() ?? null;
};

const extractStyleColor = (style: string | null | undefined): string | null => {
    const colorDeclaration = style?.match(/(?:^|;)\s*color\s*:\s*([^;]+)\s*(?:;|$)/i);

    return colorDeclaration?.[1].trim() ?? null;
};

export const parseColorDeclaration = (element: HTMLElement): string | null => {
    const ownColor = extractStyleColor(element.getAttribute('style'));
    if (ownColor) {
        return ownColor;
    }

    const descendantColor = Array.from(element.querySelectorAll<HTMLElement>('[style*="color"]')).reduce<string | null>(
        (foundColor, descendant) => foundColor ?? extractStyleColor(descendant.getAttribute('style')),
        null
    );
    if (descendantColor) {
        return descendantColor;
    }

    return element.querySelector('[color]')?.getAttribute('color') ?? null;
};

export const TableCellWithBorder = TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            border: {
                default: null,
                parseHTML: parseBorderDeclaration,
                renderHTML: ({ border }) => (border ? { style: `border: ${border}` } : {}),
            },
            color: {
                default: null,
                parseHTML: parseColorDeclaration,
                renderHTML: ({ color }) => (color ? { style: `color: ${color}` } : {}),
            },
            padding: {
                default: null,
                parseHTML: parsePaddingDeclaration,
                renderHTML: ({ padding }) => (padding ? { style: `padding: ${padding}` } : {}),
            },
        };
    },
});

export const TableHeaderWithBorder = TableHeader.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            border: {
                default: null,
                parseHTML: parseBorderDeclaration,
                renderHTML: ({ border }) => (border ? { style: `border: ${border}` } : {}),
            },
            color: {
                default: null,
                parseHTML: parseColorDeclaration,
                renderHTML: ({ color }) => (color ? { style: `color: ${color}` } : {}),
            },
            padding: {
                default: null,
                parseHTML: parsePaddingDeclaration,
                renderHTML: ({ padding }) => (padding ? { style: `padding: ${padding}` } : {}),
            },
        };
    },
});

export const ParagraphWithPadding = Paragraph.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            padding: {
                default: null,
                parseHTML: parsePaddingDeclaration,
                renderHTML: ({ padding }) => (padding ? { style: `padding: ${padding}` } : {}),
            },
        };
    },
});

export const HeadingWithPadding = Heading.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            padding: {
                default: null,
                parseHTML: parsePaddingDeclaration,
                renderHTML: ({ padding }) => (padding ? { style: `padding: ${padding}` } : {}),
            },
        };
    },
});
